export const galleryData = [
  {
    id: 'photography',
    title: 'Photography',
    images: [
      {
        file: 'montreux.JPG',
        focus: 'center',
        location: 'Montreux, Switzerland',
        date: 'May, 2026',
      },
      {
        file: 'switzerland.JPG',
        focus: 'center',
        location: 'Lauterbrunnen, Switzerland',
        date: 'May, 2026',
      },
      {
        file: 'powerplant-sunset.JPG',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'May, 2026',
      },
      {
        file: 'chapel-hill-mural.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'April, 2026',
      },
      {
        file: 'empire-state.jpg',
        focus: 'center',
        location: 'New York, New York',
        date: 'December, 2025',
      },
      {
        file: 'peach-pit.JPG',
        focus: 'center',
        location: 'Raleigh, North Carolina',
        date: 'October, 2025',
      },
      {
        file: 'moon-garage.jpg',
        focus: 'center',
        location: 'Austin, Texas',
        date: 'August, 2025',
      },
      {
        file: 'battles.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'March, 2025',
      },
      {
        file: 'atc-lake.JPG',
        focus: 'center',
        location: 'Henrico, North Carolina',
        date: 'November, 2024',
      },
      {
        file: 'bergen-view.JPG',
        focus: 'center',
        location: 'Bergen, Norway',
        date: 'June, 2024',
      },
      {
        file: 'nat-cph.JPG',
        focus: 'top',
        location: 'Copenhagen, Denmark',
        date: 'June, 2024',
      },
      {
        file: 'diving-cph.JPG',
        focus: 'top',
        location: 'Copenhagen, Denmark',
        date: 'May, 2024',
      },
      {
        file: 'skipper-lot.jpg',
        focus: 'bottom',
        location: 'Chapel Hill, North Carolina',
        date: 'February, 2024',
      },
      {
        file: 'davis-ben.JPG',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'April, 2023',
      },
      {
        file: 'rocky-colorodo.JPG',
        focus: 'center',
        location: 'Rocky Mountains, Colorado',
        date: 'March, 2023',
      },
      {
        file: 'sf-spirals.JPG',
        focus: 'center',
        location: 'San Francisco, California',
        date: 'March, 2023',
      },
      {
        file: 'hard-things.JPG',
        focus: 'top',
        location: 'Chapel Hill, North Carolina',
        date: 'March, 2023',
      },
      {
        file: 'beach-cables.JPG',
        focus: 'left',
        location: 'Topsail Beach, North Carolina',
        date: 'November, 2021',
      },
      {
        file: 'sun-statue.JPG',
        focus: 'top',
        location: 'Lisbon, Portugal',
        date: 'November, 2021',
      },
      {
        file: 'grandmas-hands.JPG',
        focus: 'center',
        location: 'Topsail Beach, North Carolina',
        date: 'November, 2021',
      },
      {
        file: 'armando-cat.JPG',
        focus: 'center',
        location: 'Durham, North Carolina',
        date: 'June, 2020',
      },
    ],
  },
  {
    id: 'scrap-book',
    title: 'Scrap Book',
    images: [
      {
        file: 'ben-nidhi.JPG',
        focus: 'center',
        location: 'Austin, Texas',
        date: 'September, 2026',
      },
      {
        file: 'beach-trip-26.JPEG',
        focus: 'center',
        location: 'Kiawah Island, South Carolina',
        date: 'August, 2026',
      },
      {
        file: 'ben-mom-dad.jpg',
        focus: 'right',
        location: 'The Matterhorn, Switzerland',
        date: 'May, 2026',
      },
      {
        file: 'ben-aidan-grads.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'May, 2026',
      },
      {
        file: 'ben-aura.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'May, 2026',
      },
      {
        file: 'ben-golfer.JPEG',
        focus: 'left',
        location: 'Chapel Hill, North Carolina',
        date: 'May, 2026',
      },
      {
        file: 'ben-truck.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'April, 2026',
      },
      {
        file: 'ben-retreat-s26.jpg',
        focus: 'center',
        location: 'Oak Island, North Carolina',
        date: 'April, 2026',
      },
      {
        file: 'ben-debugging.JPEG',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'April, 2026',
      },
      {
        file: 'ben-snl.JPG',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'February, 2026',
      },
      {
        file: 'ben-noah-ryder.jpg',
        focus: 'center',
        location: 'New York, New York',
        date: 'December, 2025',
      },
      {
        file: 'ben-riley.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'October, 2025',
      },
      {
        file: 'ben-glass.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'October, 2025',
      },
      {
        file: 'interns.JPG',
        focus: 'left',
        location: 'Austin, Texas',
        date: 'August, 2025',
      },
      {
        file: 'ben-noah-flowers.JPG',
        focus: 'center',
        location: 'Durham, North Carolina',
        date: 'May, 2025',
      },
      {
        file: 'ben-hamsini.JPG',
        focus: 'center',
        location: 'Durham, North Carolina',
        date: 'April, 2025',
      },
      {
        file: 'ben-ram.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'April, 2025',
      },
      {
        file: 'ben-aidan.JPG',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'January, 2025',
      },
      {
        file: 'ben-fam.JPG',
        focus: 'center',
        location: 'Durham, North Carolina',
        date: 'December, 2025',
      },
      {
        file: 'thanksgiving.jpg',
        focus: 'center',
        location: 'Concord, North Carolina',
        date: 'November, 2024',
      },
      {
        file: 'halloween.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'October, 2024',
      },
      {
        file: 'ben-alex-cph.JPG',
        focus: 'center',
        location: 'Copenhagen, Denmark',
        date: 'June, 2024',
      },
      {
        file: 'ben-tekla.jpg',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'May, 2024',
      },
      {
        file: 'metro.JPG',
        focus: 'left',
        location: 'Copenhagen, Denmark',
        date: 'June, 2024',
      },
      {
        file: 'cph-bros.jpg',
        focus: 'center',
        location: 'Copenhagen, Denmark',
        date: 'May, 2024',
      },
      {
        file: 'ben-tarheel-ten.jpg',
        focus: 'top',
        location: 'Chapel Hill, North Carolina',
        date: 'April, 2024',
      },
      {
        file: 'ben-beach.jpg',
        focus: 'center',
        location: 'Topsail Beach, North Carolina',
        date: 'March, 2024',
      },
      {
        file: 'ben-asim.JPG',
        focus: 'center',
        location: 'Chapel Hill, North Carolina',
        date: 'February, 2024',
      },
      {
        file: 'ben-kiernan-ciya.jpg',
        focus: 'top',
        location: 'Mooresville, North Carolina',
        date: 'October, 2023',
      },
      {
        file: 'ben-stephen-sf.jpg',
        focus: 'top',
        location: 'San Francisco, California',
        date: 'March, 2023',
      },
    ],
  },
];
